module.exports = __webpack_public_path__ + "media/images/front/home_header-bbcd6160fd475076b7b2c6347f4d01fc.jpg";